'use strict';

module.exports = require('./components/DisqusThread');


//////////////////
// WEBPACK FOOTER
// ./~/react-disqus-thread/lib/main.js
// module id = ./node_modules/react-disqus-thread/lib/main.js
// module chunks = 5567064509904683000